import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import type {
  AbsenceLimitSettings,
  AbsenceLimitSettingsRequest,
} from '../entities/absence-limit-settings.model';

@Injectable({ providedIn: 'root' })
export class AbsenceLimitSettingsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<AbsenceLimitSettings> {
    return this.http.get<AbsenceLimitSettings>(`${this.baseUrl}/AbsenceLimitSettings`, {
      withCredentials: true,
    });
  }

  public update(body: AbsenceLimitSettingsRequest): Observable<AbsenceLimitSettings> {
    return this.http.put<AbsenceLimitSettings>(`${this.baseUrl}/AbsenceLimitSettings`, body, {
      withCredentials: true,
    });
  }
}
